import { StatusType } from './constants'

export default {
  id: null,
  status: StatusType.DRAFT,
}
